import React, { useEffect } from "react";
import QuestCards from "./QuestCards";
import "./Quest.css";
import { useGetQuestByCategory } from "../../../../hooks/teacher/quest/useGetQuestByCategory";
import classRoomImg from "../../../../assets/img/teacherDashboard/Classroom.png";
import QuestCardsSkeleton from "./QuestCardsSkeleton";

const Quest = () => {
  const { quests, loading, error, getQuestByCategory } = useGetQuestByCategory();

  const fetchQuests = async () => {
    await getQuestByCategory();
  };

  useEffect(() => {
    fetchQuests();
  }, []);

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  if (loading || quests === undefined) {
    return (
      <div className="classroom-cnt">
        <div className="classroom-container">
          <img src={classRoomImg} className="img" alt="Classroom" />
          <h2 className="text">All Quests</h2>
        </div>
        <div className="d-flex gap-3 flex-column">
          {[1, 2, 3].map((item) => (
            <QuestCardsSkeleton key={item} />
          ))}
        </div>
      </div>
    );
  }


  return (
    <div className="classroom-cnt">
      <div className="classroom-container">
        <img src={classRoomImg} className="img" alt="Classroom" />
        <h2 className="text">Total Quests</h2>
      </div>

      <div className="d-flex gap-3 flex-column">
        {quests && Object.keys(quests).length > 0 ? (
          Object.keys(quests).map((category) => (
            <QuestCards
              key={category}
              quests={quests[category]}
              questType={category}
            />
          ))
        ) : (
          <div>No quests assigned.</div>
        )}
      </div>
    </div>
  );
};

export default Quest;
